// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-user-dashboard-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        overflow: auto;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background-color: rgb(251, 253, 255);
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-user-dashboard-page-layout{
        margin-top: 10vh;
        position: relative;
        flex-grow: 1;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-user-dashboard-page-layout.full-screen{
        display: block;
    }
    .customer-user-dashboard-parent-container{
        height: 90vh;
        position: relative;
    }
    .customer-user-dashboard-container{
        height: 100%;
        display: flex;
    }
    .customer-user-dashboard-content-container{
        height: 100%;
        flex-grow: 1;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .customer-user-dashboard-controls-parent-container{
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0px 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgb(231, 231, 231);
        background-color: rgba(155, 30, 30, 0.952);
    }
    .customer-user-dashboard-controls-parent-container.shrink{
        animation: customer-user-dashboard-controls-parent-container-shrink-up 0.15s ease-out forwards;
    }
    @keyframes customer-user-dashboard-controls-parent-container-shrink-up {
        from{
            height: 100%;
        }
        to{
            height: 0;
            display: none;
        }
    }
    .customer-user-dashboard-header-controls-container{
        display: flex;
    }
    .customer-user-dashboard-header-controls-container .seperator{
        width: 2px;
        margin-left: 10px;
        background-color: white;
    }
    .customer-user-dashboard-header-controls-container button{
        display: flex;
        align-items: center;
        padding: 2px 5px;
        margin: 0px 10px;
        cursor: pointer;
        outline: none;
        border: none;
        font-size: 15px;
        border-radius: 5px;
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        box-sizing: border-box;
    }
    .customer-user-dashboard-header-controls-container img{
        height: 20px;
    }
    .customer-user-dashboard-header-controls-container.left button{
        margin-left: 0px;
    }
    .customer-user-dashboard-header-controls-container.right button{
        margin-right: 0px;
    }
    .customer-user-dashboard-header-controls-container.left p{
        margin: 0px;
        padding-top: 4px;
        color: white;
        font-size: 20px;
        font-weight: 600;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-user-dashboard-state-container{
        width: 100%;
        flex-grow: 1;
        overflow: auto;
        overflow-x: hidden;
        box-sizing: border-box;
    }
    .customer-user-dashboard-state-container.edit-widget{
        padding: 0px 2vw;
    }
    .edit-widget-section{
        width: 50%;
        height: 90vh;
        padding: 0;
        margin: 0;
        overflow: hidden;
    }
    .edit-widget-section.active{
        display: block;
    }
    .edit-widget-section.inactive{
        display: none;
    }
}
@media screen and (max-width:949px){
    .customer-user-dashboard-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        overflow: auto;
        display: flex;
        flex-direction: column;
        background-color: rgb(251, 253, 255);
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-user-dashboard-page-layout{
        margin-top: 10vh;
        flex-grow: 1;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-user-dashboard-page-layout.full-screen{
        display: block;
    }
    .customer-user-dashboard-parent-container{
        max-width: 100vw ;
        overflow: hidden;
    }
    .customer-user-dashboard-header-controls-container{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerUserStyles/Dashboards/Dashboard.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,oCAAoC;QACpC,+CAA+C;IACnD;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,cAAc;IAClB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,sBAAsB;QACtB,iBAAiB;QACjB,oBAAoB;QACpB,2CAA2C;QAC3C,0CAA0C;IAC9C;IACA;QACI,8FAA8F;IAClG;IACA;QACI;YACI,YAAY;QAChB;QACA;YACI,SAAS;YACT,aAAa;QACjB;IACJ;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,iBAAiB;QACjB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,0CAA0C;QAC1C,sBAAsB;IAC1B;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,4DAA4D;IAChE;IACA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,YAAY;QACZ,UAAU;QACV,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,oCAAoC;QACpC,+CAA+C;IACnD;IACA;QACI,gBAAgB;QAChB,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-user-dashboard-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        overflow: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n        background-color: rgb(251, 253, 255);\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-user-dashboard-page-layout{\r\n        margin-top: 10vh;\r\n        position: relative;\r\n        flex-grow: 1;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-user-dashboard-page-layout.full-screen{\r\n        display: block;\r\n    }\r\n    .customer-user-dashboard-parent-container{\r\n        height: 90vh;\r\n        position: relative;\r\n    }\r\n    .customer-user-dashboard-container{\r\n        height: 100%;\r\n        display: flex;\r\n    }\r\n    .customer-user-dashboard-content-container{\r\n        height: 100%;\r\n        flex-grow: 1;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n    }\r\n    .customer-user-dashboard-controls-parent-container{\r\n        display: flex;\r\n        justify-content: space-between;\r\n        box-sizing: border-box;\r\n        padding: 0px 15px;\r\n        padding-bottom: 10px;\r\n        border-bottom: 1px solid rgb(231, 231, 231);\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .customer-user-dashboard-controls-parent-container.shrink{\r\n        animation: customer-user-dashboard-controls-parent-container-shrink-up 0.15s ease-out forwards;\r\n    }\r\n    @keyframes customer-user-dashboard-controls-parent-container-shrink-up {\r\n        from{\r\n            height: 100%;\r\n        }\r\n        to{\r\n            height: 0;\r\n            display: none;\r\n        }\r\n    }\r\n    .customer-user-dashboard-header-controls-container{\r\n        display: flex;\r\n    }\r\n    .customer-user-dashboard-header-controls-container .seperator{\r\n        width: 2px;\r\n        margin-left: 10px;\r\n        background-color: white;\r\n    }\r\n    .customer-user-dashboard-header-controls-container button{\r\n        display: flex;\r\n        align-items: center;\r\n        padding: 2px 5px;\r\n        margin: 0px 10px;\r\n        cursor: pointer;\r\n        outline: none;\r\n        border: none;\r\n        font-size: 15px;\r\n        border-radius: 5px;\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-sizing: border-box;\r\n    }\r\n    .customer-user-dashboard-header-controls-container img{\r\n        height: 20px;\r\n    }\r\n    .customer-user-dashboard-header-controls-container.left button{\r\n        margin-left: 0px;\r\n    }\r\n    .customer-user-dashboard-header-controls-container.right button{\r\n        margin-right: 0px;\r\n    }\r\n    .customer-user-dashboard-header-controls-container.left p{\r\n        margin: 0px;\r\n        padding-top: 4px;\r\n        color: white;\r\n        font-size: 20px;\r\n        font-weight: 600;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-user-dashboard-state-container{\r\n        width: 100%;\r\n        flex-grow: 1;\r\n        overflow: auto;\r\n        overflow-x: hidden;\r\n        box-sizing: border-box;\r\n    }\r\n    .customer-user-dashboard-state-container.edit-widget{\r\n        padding: 0px 2vw;\r\n    }\r\n    .edit-widget-section{\r\n        width: 50%;\r\n        height: 90vh;\r\n        padding: 0;\r\n        margin: 0;\r\n        overflow: hidden;\r\n    }\r\n    .edit-widget-section.active{\r\n        display: block;\r\n    }\r\n    .edit-widget-section.inactive{\r\n        display: none;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-user-dashboard-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        overflow: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        background-color: rgb(251, 253, 255);\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-user-dashboard-page-layout{\r\n        margin-top: 10vh;\r\n        flex-grow: 1;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-user-dashboard-page-layout.full-screen{\r\n        display: block;\r\n    }\r\n    .customer-user-dashboard-parent-container{\r\n        max-width: 100vw ;\r\n        overflow: hidden;\r\n    }\r\n    .customer-user-dashboard-header-controls-container{\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
